<template>
  <div>
    <dashboard-module class="dashboard-item" title-slot>
      <template #title>
        <i class="el-icon-odometer title-icon"></i>
        <span class="title-year">2025</span>
        <span class="title-text">年预算执行情况</span>
      </template>
      <template #ope>
        <div class="flex">
          <div class="select-v2">
            <el-select class="query-item" v-model="queryParams.type" filterable @change="typeChange">
              <el-option v-for="item in typeList" :key="item.value" :value="item.value" :label="item.label" />
            </el-select>
          </div>
          <div class="date-picker-v2 has-icon ml16">
            <el-date-picker style="width: 180px;" v-model="queryParams.month" type="monthrange" format="yyyy-MM" value-format="yyyy-MM" :clearable="false" :picker-options="pickerOptions" @change="initBar"></el-date-picker>
          </div>
        </div>
        <div>
          <el-button class="button-v2 ml16" @click="visible = true">查看详情</el-button>
        </div>
      </template>
      <el-row :gutter="20">
        <el-col :span="15" style="border-right: 1px dashed #E8E8E8;" v-loading="loadingBar">
          <div class="chart" id="budgetPerformanceBar"></div>
          <!--<empty class="chart chart-empty" v-else />-->
        </el-col>
        <el-col :span="9" v-loading="loadingLine">
          <div class="chart" id="budgetPerformanceLine"></div>
        </el-col>
      </el-row>
    </dashboard-module>
    <el-dialog
      class="modal-v2"
      width="950px"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="总体预算"
      :visible.sync="visible"
      append-to-body
      top="2vh"
    >
      <template #title>
        <span>总体预算</span>
        <div class="progress-container">
          <el-progress :stroke-width="16" :percentage="percentage" text-inside />
        </div>
      </template>
      <div class="flex vertical acenter w100 mt20 mb20" style="max-height: calc(100vh - 200px); overflow-y: auto">
        <el-timeline style="text-align: left" v-if="visible">
          <el-timeline-item timestamp="2025年预算执行情况" placement="top" type="primary">
            <air-table
              ref="airTable"
              class="table-v2 mt15"
              style="max-height: 300px"
              :show-seq="false"
              :show-checkbox="false"
              :show-operation="false"
              align="center"
              :columns="getColumns"
              :data="getTableData"
              show-footer
              :footer-method="footerMethod"
              footer-row-class-name="footer-row"
              footer-cell-class-name="footer-cell"
            >
            </air-table>
          </el-timeline-item>
          <el-timeline-item timestamp="2024年预算执行情况" placement="top" type="info">
            <air-table
              ref="airTable"
              class="table-v2 mt15"
              style="max-height: 300px"
              :show-seq="false"
              :show-checkbox="false"
              :show-operation="false"
              align="center"
              :columns="getColumnsLastYear"
              :data="getTableDataLastYear"
              show-footer
              :footer-method="footerMethod"
              footer-row-class-name="footer-row"
              footer-cell-class-name="footer-cell"
            >
            </air-table>
          </el-timeline-item>
        </el-timeline>
      </div>
    
      <div slot="footer" class="w100 flex jend acenter">
        <el-button plain class="button-v2" @click="visible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import DashboardModule from './DashboardModule'
  import XEUtils from 'xe-utils';
  import { getMonthLaborCostByMonth, getMonthLaborCost } from '@/api/v2/stats/data-center/dashboard'
  export default {
    name: "BudgetPerformance",
    components: {
      DashboardModule
    },
    mounted() {
      this.$nextTick(() => {
        this.typeChange()
      })
    },
    data() {
      return {
        loadingBar: false,
        loadingLine: false,
        chart: null,
        pickerOptions: {
          disabledDate: (time) => {
            const currentYear = new Date().getFullYear();
            const selectedYear = time.getFullYear();
            return selectedYear !== currentYear;
          }
        },
        typeList: [
          { value: 1, label: '工资总额' },
          { value: 2, label: '人工成本总额' }
        ],
        queryParams: {
          type: 1,
          month: [this.$day().month(0).format('YYYY-MM'), this.$day().format('YYYY-MM')]
        },
        visible: false,
        optionBar: {
          grid: {
            left: '1%',
            right: '2%',
            bottom: '10',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            }
          },
          legend: {
            right: 0
          },
          xAxis: {
            type: 'category',
            axisLine: {
              lineStyle: {
                color: '#d9d9d9',
              }
            },
            axisTick: {
              alignWithLabel: true,
              lineStyle: {
                color: '#d9d9d9'
              }
            },
            axisLabel: {
              color: '#333',
              lineHeight: 24,
              interval: 0
            },
            data: []
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              formatter: '{value}W'
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          },
          series: [
            {
              name: '工资总额（万元）',
              type: 'bar',
              barWidth: '20px',
              label: {
                normal: {
                  show: true,// 显示label
                  position: "top", // 显示的label的位置
                }
              },
              data: []
            },
            {
              name: '去年同期工资总额（万元）',
              type: 'bar',
              barWidth: '20px',
              label: {
                normal: {
                  show: true,// 显示label
                  position: "top", // 显示的label的位置
                }
              },
              data: []
            }
          ]
        },
        optionLine: {
          grid: {
            left: '1%',
            right: '2%',
            bottom: '10',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            }
          },
          legend: {
            data: ['', '同比增幅（%）'],
            right: 0,
            selected: {
              '同比增幅（%）': false
            }
          },
          xAxis: {
            type: 'category',
            axisLine: {
              lineStyle: {
                color: '#d9d9d9',
              }
            },
            axisTick: {
              alignWithLabel: true,
              lineStyle: {
                color: '#d9d9d9'
              }
            },
            axisLabel: {
              color: '#333',
              lineHeight: 24,
              interval: 0
            },
            axisPointer: {
              type: 'shadow'
            },
            data: []
          },
          yAxis: [
            {
              type: 'value',
              name: '预算执行率',
              nameGap: 20,
              axisLabel: {
                formatter: '{value}%'
              }
            },
            {
              type: 'value',
              name: '同比增幅',
              nameGap: 20,
              axisLabel: {
                formatter: '{value}%'
              },
              splitLine: {
                show: false // 隐藏左侧 Y 轴分割线
              }
            }
          ],
          series: [
            {
              name: '预算执行率（%）',
              type: 'line',
              tooltip: {
                valueFormatter: function (value) {
                  return value + '%';
                }
              },
              markPoint: {
                symbol: 'pin',
                symbolSize: 50,
                symbolOffset: [0, '10%'],
                data: [
                  {
                    type: 'max',
                    name: 'Max'
                  }
                ]
              },
              label: {
                show: true
              },
              data: []
            },
            {
              name: '同比增幅（%）',
              type: 'line',
              yAxisIndex: 1,
              tooltip: {
                valueFormatter: function (value) {
                  return value + '%';
                }
              },
              data: []
            }
          ]
        },
        tableData: [],
        tableDataLastYear: [],
        percentage: 0
      }
    },
    methods: {
      typeChange() {
        this.initBar()
        this.initLine()
      },
      initBar() {
        this.loadingBar = true
        let chartDom = document.getElementById("budgetPerformanceBar");
        if (chartDom == null) {
          return
        }
        this.$echarts.dispose(chartDom);
        let myChart = this.$echarts.init(chartDom, { color: this.colorListBar });
        const params = {
          month: this.queryParams.month
        }
        const xAxisData = []
        const seriesData0 = []
        const seriesData1 = []
        getMonthLaborCostByMonth(params)
          .then(res => {
            this.loadingBar = false
            const result = res.data.data
            const { data, dataLastYear } = result
            const field = this.queryParams.type == 1 ? 'salaryCost' : 'allCost'
            data.forEach(item => {
              xAxisData.push(`${ item.month }月`)
              seriesData0.push(Math.round(item[field]))
            })
            dataLastYear.forEach(item => {
              seriesData1.push(Math.round(item[field]))
            })
            this.optionBar.xAxis.data = xAxisData
            this.optionBar.series[0].data = seriesData0
            this.optionBar.series[1].data = seriesData1
            myChart.setOption(this.optionBar);
            this.tableData = data
            this.tableDataLastYear = dataLastYear
          })
          .catch(error => {
            this.loadingBar = false
          })
      },
      initLine() {
        this.loadingLine = true
        let chartDom = document.getElementById("budgetPerformanceLine");
        if (chartDom == null) {
          return
        }
        this.$echarts.dispose(chartDom);
        let myChart = this.$echarts.init(chartDom, { color: this.colorListTrend });
        this.optionLine.yAxis.forEach((item, index) => {
          item.nameTextStyle = {
            color: this.colorListTrend[index]
          }
          item.axisLabel.color = this.colorListTrend[index]
        })
        
        const params = {
          month: this.$day().format('YYYY-MM')
        }
        const xAxisData = []
        const seriesData0 = []
        const seriesData1 = []
        getMonthLaborCost(params)
        .then(res => {
          this.loadingLine = false
          const result = res.data.data
          const { data } = result
          const field1 = this.queryParams.type == 1 ? 'budgetSalaryCost' : 'budgetAllCost'
          const field2 = this.queryParams.type == 1 ? 'salaryCostOnYear' : 'allCostOnYear'
          data.forEach((item, index) => {
            xAxisData.push(`${ item.month }月`)
            seriesData0.push(item[field1])
            seriesData1.push(item[field2])
            if (index === data.length - 1) {
              this.percentage = item.budgetAllCost
            }
          })
          this.optionLine.xAxis.data = xAxisData
          this.optionLine.series[0].data = seriesData0
          this.optionLine.series[1].data = seriesData1
          this.setTypeLabel()
          myChart.setOption(this.optionLine);
        })
        .catch(error => {
          this.loadingLine = false
        })
      },
      setTypeLabel() {
        const { type } = this.queryParams
        const typeMap = {}
        this.typeList.forEach(item => {
          typeMap[item.value] =  item.label
        })
        this.optionLine.legend.data[0] = `${ typeMap[type] }预算执行率（%）`
        this.optionLine.series[0].name = `${ typeMap[type] }预算执行率（%）`
      },
      footerMethod ({ columns, data }, index) {
        const fields = ['fixedSalary', 'performanceBonus', 'collaborativeBonus', 'socialSecAndFund', 'otherCost', 'allCost']
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '成本合计'
            }
            if (fields.includes(column.property)) {
              return XEUtils.sum(data, column.property)
            }
            return null
          })
        ]
      }
    },
    computed: {
      ...mapGetters(['colorListBar', 'colorListTrend']),
      getColumns(){
        const dynamicColumns = [
          { field: 'wageMonth', title: '单位：中粮信托', width: 160 },
          { field: 'fixedSalary', title: '固薪及补贴', width: 120 },
          { field: 'performanceBonus', title: '绩效奖金', width: 120 },
          { field: 'collaborativeBonus', title: '协同奖金', width: 120 },
          { field: 'socialSecAndFund', title: '五险二金', width: 120 },
          { field: 'otherCost', title: '其他', width: 120 },
          { field: 'allCost', title: '人工成本总额', width: 120 }
        ]
    
        return dynamicColumns
      },
      getTableData() {
        return [...this.tableData]
      },
      getColumnsLastYear(){
        const dynamicColumns = [
          { field: 'wageMonth', title: '去年同期', width: 160 },
          { field: 'fixedSalary', title: '固薪及补贴', width: 120 },
          { field: 'performanceBonus', title: '绩效奖金', width: 120 },
          { field: 'collaborativeBonus', title: '协同奖金', width: 120 },
          { field: 'socialSecAndFund', title: '五险二金', width: 120 },
          { field: 'otherCost', title: '其他', width: 120 },
          { field: 'allCost', title: '人工成本总额', width: 120 }
        ]
    
        return dynamicColumns
      },
      getTableDataLastYear() {
        return [...this.tableDataLastYear]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .chart {
    height: 400px;
  }
  .query-item {
    width: 130px;
  }
</style>
